import { getStorage, ref, getDownloadURL } from "firebase/storage";

export default {
    namespaced: true,
    state: {
        event: null,
        emptyImageUrl: null,
    },
    mutations: {
        SET_EVENT(state, events) {
            state.event = events
        },
        SET_EMPTY_IMAGE_URL(state, url) {
            state.emptyImageUrl = url;
        },
    },
    getters: {
        event: (state) => state.event,
        emptyImageUrl: (state) => state.emptyImageUrl,
    },
    actions: {
        fetchEmptyImage({ commit }) {
            const storage = getStorage();
            const storageRef = ref(storage, "Event Photos/empty-image-placeholder.png");

            getDownloadURL(storageRef).then((url) => {
                commit('SET_EMPTY_IMAGE_URL', url);
            }).catch((error) => {
                console.log(error)
            });
        },
    },
}